var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryServices2 = function SvgCategoryServices2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_services2_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_services2_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_services2_svg__st0",
    d: "m33.3 19.1-18.7.1c-.9 0-1.7-.7-1.7-1.7v-3.9c0-.9.7-1.7 1.7-1.7h18.6c.9 0 1.7.7 1.7 1.7v3.9c.1.8-.6 1.6-1.6 1.6zM21.2 36v-6.6c0-.6.5-1 1-1h1.6c.6 0 1 .5 1 1V36c0 .6-.5 1-1 1h-1.6c-.5-.1-1-.5-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_services2_svg__st0",
    d: "M34.4 15.5H37.7c.7.1 1.4.8 1.4 1.5v1.1c0 .9-.4 1.8-1.1 2.3-.5.4-1 .7-1.7.9L25 23.6c-1 .3-1.7 1.3-1.7 2.3v2.4"
  })));
};
export default SvgCategoryServices2;